import * as Sentry from '@sentry/vue';
import Vue from 'vue';

export default function initSentry(router = null) {
    const appUrl = process.env.MIX_APP_URL;
    const appEnv = process.env.MIX_APP_ENV;

    const tracePropagationTargets = [];
    if (appUrl) {
        tracePropagationTargets.push(appUrl + '/api');
        tracePropagationTargets.push(appUrl + '/vue');
    }

    const integrations = [
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration(),
    ];

    if (router) {
        integrations.push(Sentry.browserTracingIntegration({ router }));
    } else {
        integrations.push(Sentry.browserTracingIntegration());
    }

    Sentry.init({
        Vue,
        dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
        environment: appEnv,
        integrations,

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.1,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets,

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,

        ignoreTransactions: [
            '/api/user/activity',
        ],

        ignoreErrors: [
            /Network Error/i, // Caused mostly because of computers in hibernation
        ],
    });
}
